// src/pages/TradingData/SharedComponents.jsx
// Reusable styled components for TradingData

import React from 'react';
import { Button, Typography, alpha } from '@mui/material';
import { MONO } from './IndicatorConfigs';

export const Pill = ({ active, activeColor, children, onClick, sx = {} }) => (
  <Button onClick={onClick} variant="outlined" size="small" sx={{
    flex: 1, minWidth: 0, py: 0.7, fontSize: '0.72rem', fontWeight: 700, fontFamily: MONO,
    letterSpacing: '0.05em', borderRadius: 1.5, textTransform: 'none',
    borderColor: active ? activeColor : alpha('#fff', 0.08),
    bgcolor: active ? alpha(activeColor, 0.12) : 'transparent',
    color: active ? activeColor : alpha('#fff', 0.3),
    '&:hover': {
      borderColor: active ? activeColor : alpha('#fff', 0.2),
      bgcolor: active ? alpha(activeColor, 0.18) : alpha('#fff', 0.04),
    },
    ...sx,
  }}>
    {children}
  </Button>
);

export const Label = ({ children }) => (
  <Typography sx={{
    color: alpha('#fff', 0.35), fontSize: '0.55rem', fontWeight: 700,
    letterSpacing: '0.2em', textTransform: 'uppercase', fontFamily: MONO, mb: 0.4,
  }}>
    {children}
  </Typography>
);
